module.exports = __webpack_public_path__ + "img/y.1a22c803.jpg";